var styles = {
  "Section": "Online-Store-UI-SelectionList__Section_1tmhk",
  "hasTitle": "Online-Store-UI-SelectionList--hasTitle_1e1em",
  "Title": "Online-Store-UI-SelectionList__Title_1k55c",
  "List": "Online-Store-UI-SelectionList__List_1s4px"
};

export { styles as default };
